<template>
    <div>
        <v-form v-model="form" ref="prepay_reservation">
            <contact-information :validation-id="v__validationId" class="mt-5" ></contact-information>
            <renters-simple-list class="mt-5"></renters-simple-list>
            <!-- <v-card>
                <v-row class="m-2 pt-5 pb-5">
                    <v-col md="6"></v-col>
                    <v-col md="6" class="text-right">
                        <h4>Total Amount</h4>
                        <div class="text-right p-2 rounded total-price">
                            <span v-if="prepay_total_packages_price!==0">
                                ${{prepay_total_packages_price}}
                            </span>
                        </div>
                    </v-col>
                </v-row>
            </v-card> -->
            <steps-navigation
                :errors="v__getErrors()"
                :back-button="false"
                :next-button="'Continue'"
                @step-next="stepNext"
            ></steps-navigation>
        </v-form>
        <v-dialog v-model="messageDialog.show" persistent max-width="500px">
            <message-modal :message="messageDialog.message" :success="messageDialog.success"></message-modal>
        </v-dialog>
    </div>
</template>

<script>
import MessageModal          from "../../../components/modals/MessageModal";
import ContactInformation       from "./step1/ContactInformation";
import ValidatableComponent from "../../../mixins/ValidatableComponent";
import {mapActions, mapGetters} from "vuex";
import StepperComponentMixin from "../../../mixins/StepperComponentMixin";
import UiManagerMixin from "../../../mixins/UiManagerMixin";
import StepsNavigation from "../../../components/partials/StepsNavigation";
import RentersSimpleList from "../../../components/partials/RentersSimpleList";
import prepay_form__fields from "../../../validation/fields/prepay_form__fields";
import moment from "moment";
import prepay_form__rules from "../../../validation/scenarios/prepay_form__rules";
import prepay_canadian_form__rules from "../../../validation/scenarios/prepay_canadian_form__rules";

export default {
    name: "StepPrepayPage",
    components: {MessageModal, StepsNavigation, ContactInformation, RentersSimpleList},
    mixins: [StepperComponentMixin,ValidatableComponent, UiManagerMixin],
    data: () => ({
        form: false,
        messageDialog: {
            show   : false,
            message: '',
            success: true
        },
        is_prepay: false,
        errorMessagesList: [],
    }),
    methods: {
        ...mapActions(['do_store_prepay_reservation']),
        async stepSubmit() {
            if( this.$store.state.model.reservees.length == 0 ){
                this.addErrors([{'message': "Please add a renter!"}]);
            }else{
                this.clearErrors(0);
            }
            let errorsList = this.v__getErrors();
            try {
                if(errorsList.length === 0){
                    const result = await this.do_store_prepay_reservation();
                    if(result.data.success){
                        return true;
                    }
                    if(result.data.success && (this.prepay_payment!==1 || this.only_save_card_at_prepay!==1)){
                        this.showMessage('Prepaid Successfully');
                        return false;
                    }
                }
            } catch (e) {
                if (e.isCustomError) {
                    switch (e.type) {
                        case 'validation':
                            for (let attr in e.data.errors) {
                                this.addErrors(e.data.errors[attr].map(e => ({attr,message:e})));
                            }
                            break;
                    }
                }
                console.log(e);
            }

            return false;
        },
        showMessage(text, success) {
            this.messageDialog.message = text;
            this.messageDialog.success = success === undefined ? true : success;
            this.messageDialog.show = true;
            const self = this;
            setTimeout(function(){
                self.messageDialog.show = false;
                self.reload();
            },3000);
        },
        reload(){
            window.location.reload();
        }
    },
    computed: {
        config(){
            return this.$store.state.resources.config;
        },
        is_international_canadian(){
            return parseInt(this.$store.state.resources.config.is_international_canadian);
        },
        prepay_payment(){
            return parseInt(this.$store.state.resources.config.prepay_payment);
        },
        only_save_card_at_prepay(){
            return parseInt(this.$store.state.resources.config.only_save_card_at_prepay);
        },
        welcome_text_in_advance() {
            return parseInt(this.$store.state.resources.config.welcome_text_in_advance);
        },
        return_customer_prepay() {
            return parseInt(this.$store.state.resources.config.return_customer_prepay);
        },
        ...mapGetters(['prepay_special_fee', 'prepay_total_packages_price'])

    },
    mounted() {
        if(this.return_customer_prepay){
            this.ui__openModalByName({name:'dialog_prepay_return'})
        }
        if(this.welcome_text_in_advance){
            this.ui__openModalByName({name:'dialog_welcome_text'})
        }
        if(window.location.href.includes('prepay')){
            this.is_prepay = true;
            this.$store.commit('set_model_value',{path:'model.reservation.is_prepay',value: 1})
            this.$store.commit('set_model_value',{path:'model.reservation.date_pickup',value: moment(new Date()).format("MM/DD/YYYY")})
            this.$store.commit('set_model_value',{path:'model.reservation.date_return',value:this.$store.state.resources.config.season_return})
        }
        const self = this;
        this.withValidation({
            getModel() {
                return self.$store.state.model.reservation;
            },
            rules : parseInt(this.$store.state.resources.config.is_international_canadian)?prepay_canadian_form__rules:prepay_form__rules,
            fields: prepay_form__fields
        })
    }
}
</script>

<style scoped>
    .total-price{
        width: 125px;
        min-height: 42px;
        float: right;
        background: #e4f3fe;
        border-color: #e4f3fe;
        color: blue;
        font-size: 18px;
    }
</style>
